export var USER_TYPE = {
  mobile: 0,
  fttb: 1,
  convergent: 2
};
export var PAYMENT_METHODS_SLUGS = {
  fps: 'fps',
  card: 'card',
  apple: 'apple',
  google: 'google',
  sberpay: 'sberpay',
  savedCards: 'savedCards'
};
export var FPS_ICON = 'https://static.beeline.ru/upload/images/b2c/index-redesign-payment-icons/sfp.svg';